import React from 'react';
import ReactDOM from 'react-dom';
import { Map, MapApiLoaderHOC,ZoomControl,Marker } from 'react-bmapgl'

class Example extends React.Component {
  render() {
    const { ...tagProps } = this.props;
    const { lng ,lat} = tagProps;
    return (
      <Map
        style={{ height:'100%' }}
        center={{lng: lng, lat: lat}}
        zoom={12}
      >
        <Marker position={{lng: lng, lat: lat}} />
         <ZoomControl />
        </Map>
    )
  }
}

export default MapApiLoaderHOC({ak: '8E628bf0219dc2f4d67fd4400d584315'})(Example)